import { styled } from 'baseui'
import { pollColor } from '@/shared/tools/communicationBoardPolls'

export const VoterRow = styled('li', ({ $theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(8rem, 1.4fr) minmax(6rem, 1fr) minmax(8rem, 1fr) 7.5rem',
  alignItems: 'center',
  gap: '0.75rem',
  paddingTop: '0.5rem',
  paddingBottom: '0.5rem',
  fontSize: '0.75rem',
  color: $theme.colors.textPulseLabel,
  borderBottom: `1px solid ${$theme.colors.borderPulse}`,
}))

export const VoterName = styled('span', ({ $theme }) => ({
  fontWeight: 600,
  color: $theme.colors.textPulseStrong,
}))

export const VoterScore = styled<'span', { $colorKey: string }>('span', ({ $theme, $colorKey }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.375rem',
  color: pollColor($theme, $colorKey),
}))

export const VoterDate = styled('span', ({ $theme }) => ({
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
  color: $theme.colors.textPulseMuted,
}))

export const VoterComment = styled('span', ({ $theme }) => ({
  gridColumn: '1 / -1',
  fontStyle: 'italic',
  lineHeight: '1.4',
  whiteSpace: 'pre-line',
  overflowWrap: 'anywhere',
  color: $theme.colors.textPulseLabel,
}))
